var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgNoperson = function SvgImgNoperson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img_noperson_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E2E2E2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.438 53.253v-.575c0-3.191-2.593-5.75-5.763-5.75H34.764A5.755 5.755 0 0 0 29 52.678v1.926c0 7.562 7.146 15.353 19.22 15.353a26.95 26.95 0 0 0 3.111-.201c1.96 4.284 6.253 7.274 11.266 7.274 6.83 0 12.39-5.55 12.39-12.363 0-5.089-3.111-9.488-7.549-11.357v-.057Zm-4.87 20.873c-5.243 0-9.508-4.255-9.508-9.488s4.264-9.488 9.509-9.488c5.244 0 9.508 4.256 9.508 9.488 0 5.233-4.264 9.488-9.508 9.488ZM48.22 43.103c5.84 0 10.574-4.724 10.574-10.552C58.794 26.724 54.06 22 48.22 22c-5.84 0-10.575 4.724-10.575 10.551 0 5.828 4.735 10.552 10.575 10.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.93 64.61 2.162-2.157a1.646 1.646 0 0 0 0-2.357 1.655 1.655 0 0 0-2.363 0l-2.161 2.156-2.161-2.156a1.655 1.655 0 0 0-2.363 0 1.646 1.646 0 0 0 0 2.357l2.161 2.156-2.161 2.157a1.646 1.646 0 0 0 0 2.357c.317.316.75.489 1.181.489.432 0 .865-.172 1.182-.489l2.16-2.156 2.162 2.156c.317.316.749.489 1.181.489.433 0 .865-.172 1.182-.489a1.646 1.646 0 0 0 0-2.357l-2.161-2.157Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "img_noperson_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
};
export default SvgImgNoperson;